import React from "react";
import { Location } from "@navigation/Location";
import { AccommodationConfirmationCreatePage } from "../AccommodationDocumentUploader/AccommodationConfirmationCreatePage";
import { WeekYear } from "@bonliva-crm/common";

interface Params {
  bookingId: string;
  files: File[];
  week: WeekYear;
}

export class AccommodationConfirmationCreateLocation extends Location<Params> {
  render() {
    return (
      <AccommodationConfirmationCreatePage
        bookingId={this.params.bookingId}
        files={this.params.files}
        week={this.params.week}
      />
    );
  }

  equals(location: Location<Params>) {
    return this.params.bookingId === location.params.bookingId;
  }

  toURI() {
    return `/bookings/${this.params.bookingId}/confirm-accommodation`;
  }
}
